import type { SVGProps } from "react";

export default function ArrowLeftIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.6667 8H3.33333M3.33333 8L7.33333 12M3.33333 8L7.33333 4"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
